export default __webpack_public_path__ + "static/media/productHealthCheckPackage2_all_En.b1a3b42c.webp";